import { createStyle } from "~/common/utils/create-style";

const dataSourcesDialogStyle = createStyle({
  slots: {
    dialog:
      "fixed inset-0 z-1000 flex size-full flex-col items-center justify-center outline-hidden",
    container: [
      "flex h-screen w-full flex-col bg-surface-on-light-10 px-24 py-[40px]",
      "sm:size-auto sm:rounded-xl sm:max-w-[58rem]",
      "text-text-primary-on-light",
    ],
    heading: "flex flex-col gap-8 text-title-3 text-center pb-8",
    description:
      "text-pretty text-body-1 font-normal tracking-wide text-center",
    list: "py-[24px]",
    continueButton: "p-[14px] cursor-pointer",
    bottomText: "text-center pt-12 text-body-2",
  },
  variants: {
    theme: {
      light: {
        container:
          "border-border-solid-20 shadow-[0_-1px_6px_rgba(0,0,0,0.08),0_4px_6px_rgba(0,0,0,0.08)]",
      },
    },
  },
})();

export { dataSourcesDialogStyle };
